import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import { formatPriceString } from "utils";

const NOT_FOR_DISPLAY_CATEGORIES = ["Primary"];

const titleMap: { [key: string]: string } = {
  selected_plan: "Selected Plan",
  new_plan: "New Plan",
  current_plan: "Current Plan",
};

function CartInfoMonthlyDetailsModal({
  show,
  variation,
  cart,
  handleClose,
}: {
  show: boolean;
  variation: string;
  handleClose: () => void;
  cart: any;
}) {
  const renderCartProducts = () => {
    return cart.list?.cartProducts?.map((product: any) => {
      const categories = product.categories.reduce((a: any, category: any) => {
        a[category.name] = category;
        return a;
      }, {});

      const promotions = product.categories
        .flatMap((category: any) => category.cartServiceOptions)
        .filter((service: any) => service.promotionId > 0 || service.promotionName !== null);

      const rows = [
        <Row key={product.id} className="mb-2">
          <Col xs={8}>
            <strong>{product.productName}</strong>
          </Col>
          <Col xs={4} className="text-end">
            <strong>{formatPriceString(categories?.Primary?.cartServiceOptions[0]?.cost)}</strong>
          </Col>
        </Row>,
      ];

      promotions.forEach((promotion: any) => {
        rows.push(
          <Row key={promotion.promotionId + "_promotion"} className="mb-2 customize-price-text">
            <Col xs={8}>{promotion.promotionName}</Col>
            <Col xs={4} className="text-end">
              {formatPriceString(promotion.promotionSavings)}
            </Col>
          </Row>
        );
      });

      product.categories
        .filter((category: any) => NOT_FOR_DISPLAY_CATEGORIES.indexOf(category.name) === -1)
        .map((category: any) => category.cartServiceOptions)
        .flat()
        .filter((option: any) => (option.selectedQuantity > 0 && option.frequency !== "N") || option.serviceOptionId === 862)
        .forEach((option: any) => {
          rows.push(
            <Row key={option.id + "_service_option"} className="mb-2">
              <Col xs={8}>{option.serviceOptionName}</Col>
              <Col xs={4} className="text-end">
                {option.cost !== "" ? formatPriceString(option.cost) : ""}
              </Col>
            </Row>
          );
        });

      product.notInCatalog
        ?.flatMap((item: any) => item.cartServiceOptions)
        .forEach((serviceOption: any, index: number) =>
          rows.push(
            <Row key={index + "_not_in_catalog"} className="mb-2">
              <Col xs={8}>{serviceOption.serviceOptionName}</Col>
              <Col xs={4} className="text-end">
                {formatPriceString(serviceOption.cost)}
              </Col>
            </Row>
          )
        );

      rows.push(
        <Row>
          <Col className="step-title-divider mb-3"></Col>
        </Row>
      );

      return rows;
    });
  };

  const renderDiscounts = () => {
    let discountsArray;
    if (variation === "current_plan") {
      discountsArray = cart?.currentProducts?.discounts;
    } else {
      discountsArray = cart?.discounts;
    }

    return discountsArray?.map((discount: any, index: number) => (
      <Row className="mb-2 customize-price-text discount-line-item" key={index}>
        <Col xs={8} className="discount-line-item-name">
          <strong>{discount.name}</strong>
        </Col>
        <Col xs={4} className="text-end discount-line-item-price">
          <strong>{formatPriceString(discount.amount)}</strong>
        </Col>
      </Row>
    ));
  };

  const renderSelectedPlan = () => {
    return (
      <>
        {renderCartProducts()}
        {renderDiscounts()}
        <Row className="mb-2">
          <Col xs={8}>
            <strong>Subtotal</strong>
          </Col>
          <Col xs={4} className="text-end">
            <strong>{formatPriceString(cart.monthlySubtotal)}</strong>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col xs={8}>
            <strong>Monthly Taxes & Fees</strong>
          </Col>
          <Col xs={4} className="text-end">
            <strong>{formatPriceString(cart.monthlyTaxesAndFees)}</strong>
          </Col>
        </Row>
        <Row>
          <Col className="step-title-divider mb-3"></Col>
        </Row>
        <Row className="mb-2">
          <Col xs={8}>
            <h4>
              <strong>Total</strong>
            </h4>
          </Col>
          <Col xs={4} className="text-end">
            <h4>
              <strong>{formatPriceString(cart.totalMonthlyCharges)}</strong>
            </h4>
          </Col>
        </Row>
      </>
    );
  };

  const renderCurrentPlan = (includeNewPlan = false) => {
    return (
      <>
        {includeNewPlan && renderCartProducts()}
        {cart?.currentServices?.monthly?.map((product: any) => {
          if (
            includeNewPlan &&
            cart.list?.cartProducts?.find((cartProduct: any) => cartProduct.serviceCoreTypeName === product.serviceCoreTypeName) != null
          ) {
            return null;
          }
          const rows = [
            <Row key={product.id} className="mb-2">
              <Col xs={8}>
                <strong>{product.productName}</strong>
              </Col>
              <Col xs={4} className="text-end">
                <strong>{formatPriceString(product.cost)}</strong>
              </Col>
            </Row>,
          ];

          const promotions = product.categories
            ? product.categories
                .flatMap((category: any) => category.cartServiceOptions)
                .filter((service: any) => service.promotionId > 0 || service.promotionName !== null)
            : [];

          promotions.forEach((promotion: any) => {
            rows.push(
              <Row key={promotion.promotionId + "_promotion"} className="mb-2 customize-price-text">
                <Col xs={8}>{promotion.promotionName}</Col>
                <Col xs={4} className="text-end">
                  {formatPriceString(promotion.promotionSavings)}
                </Col>
              </Row>
            );
          });

          product.cartServiceOptions?.forEach((serviceOption: any, index: number) => {
            if (
              NOT_FOR_DISPLAY_CATEGORIES.indexOf(serviceOption.categoryName) === -1 &&
              serviceOption.currentQuantity > 0 &&
              serviceOption.frequency !== "N" &&
              Number(serviceOption.cost) !== 0
            ) {
              rows.push(
                <Row key={index + "_not_in_catalog"} className="mb-2">
                  <Col xs={8}>{serviceOption.serviceOptionName}</Col>
                  <Col xs={4} className="text-end">
                    {formatPriceString(serviceOption.cost)}
                  </Col>
                </Row>
              );
            }
          });
          rows.push(
            <Row>
              <Col className="step-title-divider mb-3"></Col>
            </Row>
          );
          return rows;
        })}
        {renderDiscounts()}
        <Row className="mb-2">
          <Col xs={8}>
            <strong>Subtotal</strong>
          </Col>
          <Col xs={4} className="text-end">
            <strong>{formatPriceString(includeNewPlan ? cart.monthlySubtotal : cart.currentServices?.monthlySubtotal)}</strong>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col xs={8}>
            <strong>Monthly Taxes & Fees</strong>
          </Col>
          <Col xs={4} className="text-end">
            <strong>{formatPriceString(includeNewPlan ? cart.monthlyTaxesAndFees : cart.currentServices?.totalTaxesAndFees)}</strong>
          </Col>
        </Row>
        <Row>
          <Col className="step-title-divider mb-3"></Col>
        </Row>
        <Row className="mb-2">
          <Col xs={8}>
            <h4>
              <strong>Total</strong>
            </h4>
          </Col>
          <Col xs={4} className="text-end">
            <h4>
              <strong>{formatPriceString(includeNewPlan ? cart.totalMonthlyCharges : cart.currentServices?.monthlyTotal)}</strong>
            </h4>
          </Col>
        </Row>
      </>
    );
  };

  const renderNewPlan = () => {
    return renderCurrentPlan(true);
  };

  const renderPlan = () => {
    if (variation === "selected_plan") {
      return renderSelectedPlan();
    } else if (variation === "current_plan") {
      return renderCurrentPlan();
    } else if (variation === "new_plan") {
      return renderNewPlan();
    }
    return <></>;
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton style={{ borderBottom: "none" }}></Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <h3>{titleMap[variation]}</h3>
            </Col>
          </Row>
          <Row>
            <Col className="step-title-divider mb-3"></Col>
          </Row>
          {renderPlan()}
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default CartInfoMonthlyDetailsModal;
